import { CheckCircle2, BookOpen, Award, FileText } from 'lucide-react';
import { useTranslation } from 'react-i18next';

interface PedagogyEvaluationProps {
  pedagogy: string[];
  evaluation: string[];
}

export function PedagogyEvaluation({
  pedagogy,
  evaluation,
}: PedagogyEvaluationProps) {
  const { t } = useTranslation('formations');

  const services = [
    {
      icon: BookOpen,
      titleKey: 'pedagogy.pedagogyTitle',
      items: pedagogy,
      color: '#F06C6E',
    },
    {
      icon: Award,
      titleKey: 'pedagogy.evaluationTitle',
      items: evaluation,
      color: '#0D974E',
    },
    {
      icon: FileText,
      titleKey: 'pedagogy.dataSupports.title',
      itemsKeys: [
        'pedagogy.dataSupports.providedData',
        'pedagogy.dataSupports.ownData',
        'pedagogy.dataSupports.pdfSupport',
        'pedagogy.dataSupports.onlineResources',
      ],
      color: '#FF9500',
    },
  ];

  return (
    <section className="py-24 bg-transparent">
      <div className="container mx-auto px-4">
        <div className="max-w-6xl mx-auto">
          <h2 className="text-3xl font-heading font-extrabold text-aspexit-black mb-4 text-center">
            {t('pedagogy.title')}
          </h2>
          <p className="text-center text-aspexit-gray mb-16 max-w-2xl mx-auto">
            {t('pedagogy.subtitle')}
          </p>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {services.map((service, index) => (
              <div
                key={index}
                className="bg-white rounded-xl p-6 shadow-sm hover:shadow-lg transition-shadow h-full flex flex-col border-2 border-border hover:border-aspexit-red/20"
              >
                <div
                  className="w-12 h-12 rounded-lg flex items-center justify-center mb-4"
                  style={{ backgroundColor: `${service.color}15` }}
                >
                  <service.icon className="w-6 h-6" style={{ color: service.color }} />
                </div>
                <h3 className="text-xl font-semibold text-aspexit-black mb-4 font-heading">
                  {t(service.titleKey)}
                </h3>
                <ul className="space-y-2 mb-6 flex-1">
                  {(service.items || service.itemsKeys?.map((key: string) => t(key))).map((item: string, i: number) => (
                    <li key={i} className="flex items-start gap-2 text-sm text-aspexit-gray">
                      <CheckCircle2
                        className="w-4 h-4 flex-shrink-0 mt-0.5"
                        style={{ color: service.color }}
                      />
                      <span>{item}</span>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
